/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput, Select, SelectItem } from '@carbon/react';

const TestToolRedirectUri = ({ value, onChange }) => {
  const [redirectUri, setRedirectUri] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setRedirectUri(value.redirectUri ?? '');
  }, [value.scramEncryptedCreds, value.redirectUri]);

  const handleChange = (event) => {
    const redirectUri = event.target.value;
    setRedirectUri(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ redirectUri });
    }
  };

  let redirectUris = value.redirectUris;
  let uriSelector;
  let uriInput;

  if (redirectUris.length > 0 && redirectUris[0] !== '') {
    // need a dropdown
    uriSelector = (
      <Select onChange={handleChange} id="redirectUri-select" defaultValue={redirectUris[0]} hideLabel>
        {redirectUris.map((param) => {
          return <SelectItem key={param} value={param} text={param} />;
        })}
        <SelectItem key={''} value={''} text={t('other')} />
      </Select>
    );
  }
  if (redirectUris[0] === '' || redirectUris.indexOf(redirectUri) === -1) {
    uriInput = (
      <TextInput
        className="redirectUriField"
        type="input"
        hideLabel={true}
        labelText={t('explorer_redirect_uri')}
        id="redirectUriField"
        value={redirectUri}
        onChange={handleChange}
      />
    );
  }

  return (
    <div className="redirectUri">
      <div className="labelText">{t('explorer_redirect_uri')}</div>
      {uriSelector}
      {uriInput}
    </div>
  );
};

export default TestToolRedirectUri;
